// routes
import { paths } from 'src/routes/paths';
// utils
import { apiBase } from 'src/api';
import { clearSession, getSessionKey, setSessionKey } from 'src/utils/session-utils';

// ----------------------------------------------------------------------

function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp: number) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();

  // Test token expires after 10s
  // const timeLeft = currentTime + 10000 - currentTime; // ~10s
  let timeLeft = exp * 1000 - currentTime;

  if (timeLeft > 2147483647) {
    timeLeft = 2147483647; // Max setTimeout
  }

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    clearSession();

    window.location.href = paths.auth.login;
  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken: string | null) => {
  if (accessToken) {
    setSessionKey('accessToken', accessToken);

    apiBase.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
    tokenExpired(exp);
  } else {
    clearSession();

    delete apiBase.defaults.headers.common.Authorization;
  }
};

export const getSession = () => {
  const accessToken = getSessionKey('accessToken');

  if (accessToken && isValidToken(accessToken)) {
    return accessToken;
  }

  return null;
};
